module.exports = __webpack_public_path__ + "static/media/satellite-dish.8e4d7059.svg";